import React, { useEffect, useState,useRef } from "react";
import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  Button, TextField, Typography, Box, IconButton,
  Divider, CircularProgress, FormControl, InputLabel,
  Select, MenuItem,
} from "@mui/material";
import { SelectChangeEvent } from "@mui/material/Select";
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import { useGetEmailTemplateQuery } from "../../../Api/attoDeskApi";        // ← adjust path
import { IEmailTemplate } from "../../../Api/Interface/api.interface";  
import ReactQuill from 'react-quill';    // ← adjust path

export interface EmailComposeDialogProps {
  open: boolean;
  onClose: () => void;
  defaultTo: string;
  defaultSubject: string;
  defaultMessage: string;
  onSend: (to: string, subject: string, message: string) => Promise<void>;
  sending: boolean;
  autoSelectKeyword?: string;
  customerName?: string; // ← add
  invoiceNo?: string;
   templateName?: string; 
}

const EmailComposeDialog: React.FC<EmailComposeDialogProps> = ({
  open, onClose, defaultTo, defaultSubject, defaultMessage,
  onSend, sending, autoSelectKeyword = "declaration",
  customerName,  
  invoiceNo,    
  templateName,
}) => {
  const [to,            setTo]            = useState(defaultTo);
  const [subject,       setSubject]       = useState(defaultSubject);
  const [message,       setMessage]       = useState(defaultMessage);
  const [selectedTplId, setSelectedTplId] = useState<string>("");

  const { data: tplData } = useGetEmailTemplateQuery({ searchText: "" });
 const templates: IEmailTemplate[] = Array.isArray(tplData?.data)
  ? (tplData?.data as IEmailTemplate[]) : [];
  

  const resolvePlaceholders = (html: string) =>
  html
    .replace(/\{\{customerName\}\}/g, customerName || "")
    .replace(/\{\{invoiceNo\}\}/g,    invoiceNo    || "");

  // Reset + auto-select declaration template each time dialog opens
const templatesRef = useRef(templates);
useEffect(() => {
  templatesRef.current = templates;
}, [templates]);

 useEffect(() => {
    if (!open) return;
    setTo(defaultTo);
    setSubject(defaultSubject);
    setMessage(defaultMessage);
  }, [open, defaultSubject, defaultMessage]);// ← only open, but reads fresh templates via ref



  const handleTemplateChange = (e: SelectChangeEvent<string>) => {
    const id = e.target.value;
    setSelectedTplId(id);
    if (!id) {
      setSubject(defaultSubject);
      setMessage(defaultMessage);
      return;
    }
    const tpl = templates.find((t) => String(t.id) === id);
    if (tpl) {
       setSubject(resolvePlaceholders(tpl.subject || defaultSubject));
      setMessage(resolvePlaceholders(tpl.message || defaultMessage)); // ← wrap
    }
  };

  return (
    <Dialog
      open={open}
      onClose={() => { if (!sending) onClose(); }}
      maxWidth="sm"
      fullWidth
      PaperProps={{ sx: { borderRadius: 3 } }}
    >
      <DialogTitle sx={{ pb: 1 }}>
        <Box display="flex" alignItems="center" justifyContent="space-between">
          <Box display="flex" alignItems="center" gap={1}>
            <EmailOutlinedIcon fontSize="small" sx={{ color: "primary.main" }} />
            <Typography variant="h6" fontWeight={500}>Send Declaration by Email</Typography>
          </Box>
          <IconButton size="small" onClick={onClose} disabled={sending} aria-label="Close">
            <CancelOutlinedIcon fontSize="small" />
          </IconButton>
        </Box>
      </DialogTitle>

      <Divider />

    <DialogContent sx={{ pt: 2.5, display: "flex", flexDirection: "column", gap: 2, overflow: "visible" }}>

        {/* Template selector */}
       

        {/* To */}
        <TextField
          label="To"
          value={to}
          onChange={(e) => setTo(e.target.value)}
          fullWidth size="small" type="email"
          placeholder="customer@example.com"
          disabled={sending}
        />

        {/* Subject */}
        <TextField
          label="Subject"
          value={subject}
          onChange={(e) => setSubject(e.target.value)}
          fullWidth size="small"
          disabled={sending}
        />

        {/* Message */}
        {/* <TextField
          label="Message"
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          fullWidth multiline rows={6} size="small"
          disabled={sending}
        /> */}

      <ReactQuill
  value={message}
  onChange={(value) => setMessage(value)}
  style={{
    height: "180px",
    marginBottom: "50px", // ← prevents toolbar/button overlap
  }}
/>

       

         <TextField
  label="Email Template"
  value={templateName || ""}
  fullWidth
  size="small"
  InputProps={{ readOnly: true }}
  sx={{ "& .MuiInputBase-input": { color: "text.secondary" } }}
/>

         <Typography variant="caption" color="text.secondary" sx={{ mt: -1 }}>
          The declaration PDF will be attached automatically.
        </Typography>

      </DialogContent>

      <DialogActions sx={{ px: 3, pb: 2.5, pt: 1 }}>
        <Button variant="outlined" onClick={onClose} disabled={sending}>
          Cancel
        </Button>
        <Button
          variant="contained"
          onClick={() => onSend(to, subject, message)}
          disabled={sending || !to.trim()}
          startIcon={
            sending
              ? <CircularProgress size={16} color="inherit" />
              : <EmailOutlinedIcon />
          }
        >
          {sending ? "Sending…" : "Send Email"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default EmailComposeDialog;